/* eslint no-console: "off",  */

import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

export default class LogoutPage extends React.Component {
  static propTypes = {
    authClient: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      loggedOut: false
    };
  }

  componentDidMount() {
    this.logout();
  }

  logout() {
    window.sessionStorage.clear();
    window.localStorage.clear();
    this.setState(
      {
        loggedOut: true
      },
      () => {
        window.location.href = `https://signin.coxautoinc.com/logout?bridge_env=${window.authClient && window.authClient.env === 'PRODUCTION' ? 'PROD' : 'QA'}`;
      }
    );
  }

  render() {
    return (
      <div>
        {this.state.loggedOut ? (
          <Redirect
            to={{
              pathname: '/',
              state: {
                accessToken: null
              }
            }}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/LogoutPage.js